import * as React from "react";
import styled, { css, keyframes } from "../../../styled/index";
const animation = keyframes `
  0%, 80%, 100% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% { 
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
`;
const DotsWrapper = styled("div") `
  text-align: center;
  > div {
    margin: 0 2px;
    width: ${({ size }) => size || 14}px;
    height: ${({ size }) => size || 14}px;
    background-color: ${({ theme, color }) => color || theme.colors.primary};
    border-radius: 100%;
    display: inline-block;
    -webkit-animation: ${({ duration }) => css `${animation} ${1.2 || duration}s infinite ease-in-out both`};
    animation: ${({ duration }) => css `${animation} ${1.2 || duration}s infinite ease-in-out both`};
  }
  .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }
  .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }
`;
export const DotsLoader = (props) => (React.createElement(DotsWrapper, { className: "spinner", ...props },
    React.createElement("div", { className: "bounce1" }),
    React.createElement("div", { className: "bounce2" }),
    React.createElement("div", { className: "bounce3" })));
//# sourceMappingURL=index.js.map